import {
  DialogContent,
  DialogContentProps,
  SxProps,
  Theme
} from '@mui/material'

interface MolsonDialogContentProps extends DialogContentProps {
  dataTestId?: string
  sx?: SxProps<Theme>
}

export const MolsonDialogContent = ({
  dataTestId,
  children,
  sx,
  ...props
}: MolsonDialogContentProps) => {
  const defaultSx = {
    marginBottom: 2
  }

  return (
    <DialogContent
      data-testid={dataTestId}
      {...props}
      sx={{ ...defaultSx, ...sx }}
    >
      {children}
    </DialogContent>
  )
}
